export default {"src":"/_next/static/media/logoHeaderLanguage.2505edb0.svg","height":242,"width":168,"blurWidth":0,"blurHeight":0};